import { render, staticRenderFns } from "./carousel-item-static.vue?vue&type=template&id=51994a5e&scoped=true"
import script from "./carousel-item-static.vue?vue&type=script&lang=js"
export * from "./carousel-item-static.vue?vue&type=script&lang=js"
import style0 from "./carousel-item-static.vue?vue&type=style&index=0&id=51994a5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51994a5e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonImage: require('/builds/wj/fe/wenjuan-homesite/components/common/image.vue').default})
